import { useEffect, useState } from 'react';

let current = { label: '', path: '' };
const listeners = new Set();

export function publishBreadcrumbLeaf(label) {
  const next = {
    label: typeof label === 'string' ? label.trim() : '',
    path: window.location.pathname
  };
  if (next.label === current.label && next.path === current.path) return;
  current = next;
  listeners.forEach((listener) => listener(current));
}

export function useBreadcrumbLeaf() {
  const [leaf, setLeaf] = useState(current);
  useEffect(() => {
    listeners.add(setLeaf);
    setLeaf(current);
    return () => listeners.delete(setLeaf);
  }, []);
  return leaf;
}
